import Joi from 'joi'

export const addMemberSchema = Joi.object({
	email: Joi.string()
		.email({ tlds: { allow: false } })
		.required()
		.label('E-Mail'),
	role: Joi.string().required().label('Team Role')
})
